import { topics } from '@/data/topics';
import { programmingTasks } from '@/data/tasks';

const RMKD_AI_URL = "https://ai.rmkd.uz/v1/chat/completions";
const RMKD_AI_KEY = "sk-956d4a9fb21f5c61-rn50x4-ee4c086d";
const RMKD_MODEL = "deepseek-v4-flash";

const SYSTEM_PROMPT = `Ты — суверенный ИИ-эксперт и архитектурный ментор платформы Study Platform.
Твоя цель — оказывать всестороннюю аналитическую и инженерную помощь:
1. Анализ кода Python/TypeScript, алгоритмическая оптимизация, соблюдение PEP8 и стандартов безопасности.
2. Проверка и консультации по модели цифровых компетенций UzDigComp-AI (7 сфер, 42 индикатора), методологиям FinTech и кадровой аттестации.
3. Разбор архитектурных паттернов распределенных систем, баз данных и API.

Отвечай профессионально, структурированно, лаконично и аргументированно. Без лишних водянистых фраз, строго по делу.`;

interface Message {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

let conversationHistory: Message[] = [];

export async function getStreamingAIResponse(
  userMessage: string,
  onChunk: (text: string) => void,
  activeTopicId?: string,
  activeTaskId?: string
): Promise<string> {
  if (conversationHistory.length === 0) {
    conversationHistory.push({ role: 'system', content: SYSTEM_PROMPT });
  }

  let promptWithContext = userMessage;
  if (activeTopicId) {
    const topic = topics.find(t => t.id === activeTopicId);
    if (topic) {
      promptWithContext = `[Контекст темы: ${topic.title}]\n${promptWithContext}`;
    }
  }

  if (activeTaskId) {
    const task = programmingTasks.find(t => t.id === activeTaskId);
    if (task) {
      promptWithContext = `[Контекст задачи: ${task.title}]\n${promptWithContext}`;
    }
  }

  conversationHistory.push({ role: 'user', content: promptWithContext });

  try {
    const response = await fetch(RMKD_AI_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${RMKD_AI_KEY}`
      },
      body: JSON.stringify({
        model: RMKD_MODEL,
        messages: conversationHistory.slice(-8),
        temperature: 0.6,
        max_tokens: 1500
      })
    });

    if (!response.ok) {
      throw new Error(`AI error: ${response.status}`);
    }

    const data = await response.json();
    const reply = data?.choices?.[0]?.message?.content || "Ответ сформирован.";
    
    // Call chunk handler for UI consistency
    onChunk(reply);
    conversationHistory.push({ role: 'assistant', content: reply });
    return reply;
  } catch (err: any) {
    console.error("AI service error:", err);
    throw err;
  }
}

export function clearConversationHistory(): void {
  conversationHistory = [];
}
